import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from './account/services/cookie-management.service';
import { AppConfig } from './config-service/app.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public isSpa:boolean = true;

  constructor(
    translate: TranslateService, 
    private titleService: Title,
    private location: Location
  ){
    translate.use('en');
    translate.setDefaultLang('en');
    translate.addLangs(['tr', 'en']);
    translate.get(AppConfig.settings.city.pageTitle).subscribe((res: string) => {
      this.setTitle(res);
    });
  }

  ngOnInit(){
    if(this.location.path().includes('paymentResults')){
      this.isSpa = false;
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

}
